
export const environment = {
  production: true,
  apiUrl: 'https://optohistorias.com/backend/api',
  citas: {
    horaInicio: 6, // 6:00 AM
    horaFin: 20    // 8:00 PM (20:00)
  }
};

/*
export const environment = {
  production: false,
  apiUrl: 'http://localhost/opticast/backend/api',
  citas: {
    horaInicio: 6, // 6:00 AM
    horaFin: 20    // 8:00 PM (20:00)
  }
};
*/


